import { render } from "./user-permission.vue?vue&type=template&id=03ae26d6"
import script from "./user-permission.vue?vue&type=script&lang=js"
export * from "./user-permission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__